export default {
  paused: 'Online-Zahlungen sind aufgrund von KYC-Verifizierungsproblemen pausiert.',
  deadline_warning:
    'Eine KYC-Verifizierung ist erforderlich, andernfalls werden Online-Zahlungen am {{date}} pausiert.',
  complete_verification: 'Verifizierung abschließen',
  partner: {
    action_needed:
      'Ihr Zahlungsanbieter benötigt noch eine Angabe, bevor dieses Restaurant Online-Zahlungen annehmen kann.',
    hosted_incomplete:
      'Sie haben die Einrichtung der Online-Zahlungen bei Ihrem Zahlungsanbieter noch nicht abgeschlossen.',
    link_expired:
      'Ihr Link zum Abschließen der Online-Zahlungen ist abgelaufen. Holen Sie sich einen neuen und fahren Sie fort.',
    open_error: 'Der Zahlungsanbieter ist gerade nicht erreichbar. Bitte versuchen Sie es in ein paar Minuten erneut.',
    hosted_not_started: 'Online-Zahlungen sind bei Ihrem Zahlungsanbieter noch nicht eingerichtet.',
    business_details_missing: 'Ergänzen Sie Ihre Unternehmensangaben, um Online-Zahlungen anzunehmen.',
    continue: 'Weiter',
  },
};
